/**
 * Accessibility fixes for markup this theme does not author.
 *
 * Everything here exists because a third party injects DOM we cannot edit at
 * source. Anything we DO author should be fixed in the Liquid, not here.
 *
 * Created 2026-08-17 as part of the ADA remediation.
 * See plans/2026-08-14_ada-accessibility-remediation.md
 */
(function () {
  'use strict';

  /**
   * Google Customer Reviews badge (layout/theme.liquid, gapi ratingbadge,
   * merchant_id 1122632) renders an <iframe> with no title attribute, on every
   * page. A frame with no accessible name is announced as an unlabelled frame
   * and gives a screen-reader user nothing to decide with.
   *
   * axe rule: frame-title. WCAG 4.1.2 Name, Role, Value (Level A).
   */
  var GCR_TITLE = 'Google Customer Reviews rating';
  // The badge frame is served from google.com/shopping/customerreviews/. Other Google frames (Maps,
  // reCAPTCHA, gapi widgets with I0_ ids) must not be labelled as the reviews badge.
  var GCR_SRC = /google\.com\/shopping\/customerreviews\//;

  function titleGoogleBadgeFrames(root) {
    var frames = (root || document).querySelectorAll(
      'iframe:not([title]):not([aria-label]):not([aria-hidden="true"])'
    );
    for (var i = 0; i < frames.length; i++) {
      var f = frames[i];
      // Current gapi renders /shopping/merchantverse/ inside our owned badge container.
      // Container identity also covers later provider URL changes without mislabelling other Google frames.
      if (f.closest('#hfs-gcr-badge') || GCR_SRC.test(f.getAttribute('src') || '')) {
        f.setAttribute('title', GCR_TITLE);
      }
    }
  }


  /**
   * Announce filter and sort results.
   *
   * facets.js replaces #ProductGridContainer.innerHTML and the count text on every filter or sort
   * change. Anything observing a node inside the replaced markup (this file used to watch
   * div.collection) is detached by the first update and never fires again, so the observer approach
   * is dead on collection pages. Instead facets.js dispatches `hfs:facets-updated` on document after the
   * grid, filters and count are all rendered, with the count text in event.detail.count.
   *
   * The region below is created once, lives in <body> outside any replaced markup, and is never torn
   * down. It is the only live region for the count: the old role="status" on the count wrappers was
   * removed so the same text is not spoken twice.
   *
   * WCAG 4.1.3 Status Messages (Level AA).
   */
  function installFilterStatus() {
    if (!document.getElementById('ProductGridContainer') && !document.querySelector('facet-filters-form')) return;

    var region = document.getElementById('a11y-filter-status');
    if (!region) {
      region = document.createElement('div');
      region.id = 'a11y-filter-status';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      // Visually hidden, but not display:none, which would stop it announcing.
      region.style.cssText =
        'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;' +
        'clip:rect(0 0 0 0);white-space:nowrap;border:0;';
      document.body.appendChild(region);
    }

    var timer;
    document.addEventListener('hfs:facets-updated', function (event) {
      var text = event && event.detail && event.detail.count;
      if (!text) {
        var el = document.querySelector('#ProductCountDesktop, #ProductCount');
        text = el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
      }
      if (!text) return;
      // Clear first so an unchanged count (for example a sort change) is still read out again.
      region.textContent = '';
      clearTimeout(timer);
      timer = setTimeout(function () { region.textContent = text; }, 100);
    });
  }

  function start() {
    titleGoogleBadgeFrames(document);
    installFilterStatus();
    // The badge is injected asynchronously well after load, and gapi may
    // re-render it, so watch rather than run once.
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'IFRAME') {
            titleGoogleBadgeFrames(n.parentNode || document);
          } else if (n.querySelector && n.querySelector('iframe')) {
            titleGoogleBadgeFrames(n);
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    // gapi can set the frame src after inserting it, so also watch src changes.
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t.tagName === 'IFRAME') titleGoogleBadgeFrames(t.parentNode || document);
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['src'], subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
